<template>
  <b-container class="mt-5" fluid>
    <b-row>
      <b-col>
        <h4 clas="text-center">Password Reset</h4>
        <b-form-group v-if="creds">
          <label v-if="creds.password.length !== 0">New password</label>
          <b-input
            type="password"
            :maxlength="255"
            v-model="creds.password"
            placeholder="Enter new password."
          />
        </b-form-group>
        <b-form-group v-if="creds">
          <label v-if="creds.password.length !== 0">Confirm Password</label>
          <b-input
            type="password"
            :maxlength="255"
            v-model="creds.confirm"
            placeholder="Confirm password"
          />
        </b-form-group>
        <!-- <h5>token: {{ tk }}</h5> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button class="action-button" variant="blue" @click="onSubmit">
          Reset
        </b-button>
      </b-col>
      <b-col class="d-flex justify-content-start">
        <b-button class="action-button" variant="orange" @click="onCancel">
          Cancel
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["tk"],
  data() {
    return {
      creds: {
        token: this.tk,
        password: "",
        confirm: ""
      }
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.$store.dispatch("user/resetPass", this.creds).then(r => {
        if (r) {
          this.$router.push("/");
        } else {
          return;
        }
      });
    },
    onCancel() {
      this.$router.push("/");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ResetPassword.vue